import { render, staticRenderFns } from "./FeaturedRental.vue?vue&type=template&id=2620a468&scoped=true&"
import script from "./FeaturedRental.vue?vue&type=script&lang=js&"
export * from "./FeaturedRental.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedRental.vue?vue&type=style&index=0&id=2620a468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620a468",
  null
  
)

export default component.exports